import React, { useEffect, useRef, useState } from 'react';
import { Box, FormLabel, Input, Stack, Tab, Tabs, TextareaAutosize } from '@mui/material';
import useBundleTranslation from 'i18n';
import { IItemFlowProps } from '../item-wrapper/index';
import JsonField from './components/JsonField';

interface DataSet {
    promptText: string;
    outputFormat: string;
    stateMap: string;
}

export default function AIAgent({ workflowItemSettings, saveItemSettings }: IItemFlowProps) {
    const { t } = useBundleTranslation(['app/admin/editor/generic-workflow/common']);

    const initialData: DataSet = (() => {
        const result: DataSet = {
            promptText: '',
            outputFormat: '',
            stateMap: '',
        };

        try {
            const tmp: any = JSON.parse(workflowItemSettings);
            if (tmp?.promptText) result.promptText = tmp.promptText;
            if (tmp?.outputFormat) result.outputFormat = tmp.outputFormat;
            if (tmp?.stateMap) result.stateMap = tmp.stateMap;
        } catch (e) {
            return result;
        }
        return result;
    })();

    const [promptText, setPromptText] = useState<string>(initialData.promptText);
    const [outputFormat, setOutputFormat] = useState<string>(initialData.outputFormat);
    const [stateMap, setStateMap] = useState<string>(initialData.stateMap);
    const isMounted = useRef(false);
    useEffect(() => {
        if (!isMounted.current) {
            isMounted.current = true;
            return;
        }

        saveItemSettings({
            promptText,
            outputFormat,
            stateMap,
        });
    }, [promptText, outputFormat, stateMap]);

    return (
        <Stack spacing={2}>
            <Box>
                <FormLabel>{t('prompt')}</FormLabel>
                <Box>
                    <TextareaAutosize
                        style={{ width: '100%' }}
                        minRows={5}
                        maxRows={20}
                        onChange={(event) => {
                            setPromptText(event.target.value);
                        }}
                        value={promptText}
                    />
                </Box>
            </Box>
            <Box>
                <FormLabel>{t('output_format')}</FormLabel>
                <JsonField
                    value={outputFormat}
                    onChange={(value) => {
                        setOutputFormat(value);
                    }}
                />
            </Box>
            <Box>
                <FormLabel>{t('state_map')}</FormLabel>
                <JsonField
                    value={stateMap}
                    onChange={(value) => {
                        setStateMap(value);
                    }}
                />
            </Box>
        </Stack>
    );
}
